import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';

import { HiddenMarketEffects } from './effects/hidden-market.effects';

@NgModule({
    imports: [CommonModule, EffectsModule.forFeature([HiddenMarketEffects])],
})
export class HiddenMarketModule {}
